"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VARIANTS = exports.TYPES = exports.INLINE_VARIANTS = exports.BACKGROUND_COLOR_MODES = void 0;
const TYPES = exports.TYPES = {
  DEFAULT: 'default',
  INLINE: 'inline',
  LINK: 'link'
};
const BACKGROUND_COLOR_MODES = exports.BACKGROUND_COLOR_MODES = {
  LIGHT: 'light',
  DARK: 'dark'
};
const VARIANTS = exports.VARIANTS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  DANGER: 'danger'
};
const INLINE_VARIANTS = exports.INLINE_VARIANTS = {
  ...VARIANTS,
  TERTIARY: 'tertiary',
  GHOST: 'ghost'
};